// Extracted from UserDetails/index.tsx's inline getSubscriptionStatusLabel —
// same backend enum ('trial'|'active'|'cancelled'|'billing_issue'|'expired'|'refunded')
// is used both by the existing user list and the new Member Success Dashboard
// segment rows, so this is shared rather than duplicated.
export const getSubscriptionStatusLabel = (
  status: string | null | undefined,
): string => {
  switch (status) {
    case "trial":
      return "Trial";
    case "active":
      return "Active";
    case "cancelled":
      return "Cancelled";
    case "billing_issue":
      return "Billing Issue";
    case "expired":
      return "Expired";
    case "refunded":
      return "Refunded";
    default:
      return "-";
  }
};
